import { jsxs as _, jsx as n } from "react/jsx-runtime";
import { Tooltip as f } from "@zapier/design-system-beta";
import { Icon as v } from "@zapier/zinnia-icons";
import { Button as B, IconButton as b } from "@zapier/design-system";
import m from "classnames";
import { emitUserInteractionEvent as h } from "../../observability/tracking/emitEvent.es.js";
import { UserInteractionEventName as F } from "../../observability/tracking/trackingTypes.es.js";
const g = "_button_1f92h_1", x = "_saved_1f92h_1", y = "_bookmarkFormButton_1f92h_9", o = {
  button: g,
  saved: x,
  default: "_default_1f92h_5",
  bookmarkFormButton: y
}, j = ({ templateBookmarkActions: l, id: a, slug: c, isZapTemplate: k, buttonVariant: d = "icon", className: r }) => {
  const { isBookmarked: t, isLoading: s, onSave: p, onUnsave: u } = l, e = t ? "Unsave template" : "Save template", i = () => {
    t ? u(a) : p(a), h(F.templateBookmarkButtonClicked, {
      event_action: "click",
      interaction_goal: e,
      option_selected: a,
      custom_tracking_fields: {
        template_slug: c,
        is_zap_template: `${k}`
      }
    });
  };
  return d === "button" ? /* @__PURE__ */ _(B, { iconPosition: "start", onPress: i, variant: "tertiary", "data-selected": t, className: m(o.bookmarkFormButton, r), isDisabled: s, children: [
    /* @__PURE__ */ n(v, { name: t ? "actionBookmarkFill" : "actionBookmark", size: 16 }),
    t ? "Saved" : "Save"
  ] }) : /* @__PURE__ */ n(f, { content: e, children: /* @__PURE__ */ n(b, { isDisabled: s, "aria-label": e, size: "small", className: m([
    o.button,
    t ? o.saved : o.default,
    r
  ]), style: {
    padding: "var(--zds-space-2, 2px)"
  }, name: t ? "actionBookmarkFill" : "actionBookmark", variant: "tertiary", onPress: i }) });
};
export {
  j as TemplateBookmarkButton
};
//# sourceMappingURL=TemplateBookmarkButton.es.js.map
